import "normalize.css/normalize.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import "@blueprintjs/icons";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/select/lib/css/blueprint-select.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import "nprogress/nprogress.css";

import React from "react";
import {createRoot} from "react-dom/client";

import {App} from "./app";

const container = document.getElementById("root");
if (!container) throw new Error("#root element not found");

const root = createRoot(container);
root.render(<App />);
